"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var RobotsMeta = function RobotsMeta(_ref) {
  var name = _ref.name,
      noIndex = _ref.noIndex,
      noFollow = _ref.noFollow;
  var content = (0, _react.useMemo)(function () {
    var values = [];
    if (noIndex) values.push('noindex');
    if (noFollow) values.push('nofollow');
    return values.join(',');
  }, [noFollow, noIndex]);

  if (!content) {
    return null;
  }

  return _react.default.createElement("meta", {
    name: name,
    content: content
  });
};

RobotsMeta.propTypes = {
  name: _propTypes.default.string,
  noFollow: _propTypes.default.bool,
  noIndex: _propTypes.default.bool
};
RobotsMeta.defaultProps = {
  name: 'robots'
};
var _default = RobotsMeta;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/elements/RobotsMeta.js
// module id = 899
// module chunks = 209 210 211 212